var OrganizationSearch;

import SearchMixin from './mixin.js';

import HierarchicalSelect from 'trunks/vue/admin/components/libs/hierarchical_select.js';

export default OrganizationSearch = Vue.extend({
  mixins: [SearchMixin],
  components: {
    'hierarchical-select': HierarchicalSelect
  },
  props: {
    selectedOrganizationIds: {
      type: Array,
      default: function() {
        return [];
      }
    },
    valuesChanged: {
      type: Function,
      default: _.noop
    },
    organizationsCounterText: [String, Number],
    organizationNameSuffix: String,
    readonly: {
      type: Boolean,
      default: false
    },
    eagerLoadChildren: {
      type: Boolean,
      default: false
    },
    resources: {
      type: String,
      default: '/admin/organizations'
    },
    countingOrganizations: {
      type: Boolean,
      default: false
    }
  },
  template: `<Popover position='bottom'
         :caret='false'
         :blockContent='true'
         :loadContent='true'
         :manualToggle='true'
         customClass='search-organization'
         @triggerClicked='triggerClicked'
         @beforeClose='clearKeyword'
         ref='popoverVm'>
  <template slot='trigger'>
    <chip-input :chips='selectedItems'
                idKey='composedId'
                nameKey='composedName'
                :wrapable='false'
                :counterText='organizationsCounterText || organizationsCount'
                :readonly='readonly'
                @chipClicked='unselect'
                @keywordChange='updateKeyword'
                ref='chipInput' />
    <i class='slp-caret-down placeholder'></i>
  </template>
  <div v-show='keyword' slot='content'>
    <search-list :items='items'
                 ref='searchListVm'
                 :toggleFunc='toggleItem'>
      <template slot='option-template' slot-scope='{ item }'>
        <div class='content'>
          <div>{{ item.name }}</div>
          <div class='organization-ancestor-names text-ellipsis vertical-middle'>
            <template v-for='ancestor_name in item.ancestor_names'>
              <span>{{ ancestor_name }}</span>
              <i class='slp-chevron-right'></i>
            </template>
          </div>
        </div>
        <i :class="selectedClass(item)" class='primary-text'></i>
      </template>
    </search-list>
  </div>
  <div v-show='!keyword' class='hierarchical-select-wrapper' slot='content'>
    <hierarchical-select
      :resources='resources'
      :initSelectedNodeIds='initialSelectedOrganizationIds'
      :nameSuffix='organizationNameSuffix'
      :readonly='readonly'
      :eagerLoadChildren='eagerLoadChildren'
      @valueChanged='hierarchicalSelectValueChanged'
      ref='organizationsSelect' />
  </div>
</Popover>`,
  data: function() {
    return {
      initialSelectedOrganizationIds: _.map(this.selectedOrganizationIds, function(id) {
        if (/\+$/.test(id)) {
          return id;
        } else {
          return parseInt(id);
        }
      }),
      organizationsCount: this.selectedOrganizationIds.length
    };
  },
  mounted: function() {
    return this._recount();
  },
  methods: {
    selectAll: function() {
      var ref;
      ref = this.$refs.organizationsSelect;
      if (ref.initialized) {
        return vm.$nextTick(function() {
          return ref.selectAll();
        });
      } else {
        return ref.$once('initCompleted', function(vm) {
          return vm.$nextTick(function() {
            return vm.selectAll();
          });
        });
      }
    },
    setValue: function(ids) {
      this.initialSelectedOrganizationIds = _.map(ids, function(id) {
        if (/\+$/.test(id)) {
          return id;
        } else {
          return parseInt(id);
        }
      });
      this.$refs.organizationsSelect.setValue(this.initialSelectedOrganizationIds);
      return this._recount();
    },
    unselect: function(item) {
      return this.$refs.organizationsSelect.unselectNode(item, item._selectedFlag === 'recursive');
    },
    toggleItem: function(item) {
      if (this.readonly) {
        return;
      }
      if (item._selected) {
        return this.$refs.organizationsSelect.unselectNode(item);
      } else {
        return this.$refs.organizationsSelect.selectNode(item);
      }
    },
    triggerClicked: function(event) {
      return this.$refs.popoverVm.open();
    },
    hierarchicalSelectValueChanged: function(vm) {
      this.selectedItems = vm.selectedNodes;
      this.$nextTick(function() {
        return this.$refs.chipInput.resize();
      });
      this.$emit('valueChanged', this);
      return this._recount(_.pluck(this.selectedItems, 'composedId'));
    },
    _addItems: function(items) {
      var organizations;
      organizations = this.$refs.organizationsSelect.hierarchy.addNodes(items);
      if (this.currentPage === 1) {
        return this.items = organizations;
      } else {
        return this.items = _.union(this.items, organizations);
      }
    },
    _recount: function(ids = this.initialSelectedOrganizationIds) {
      if (!this.countingOrganizations) {
        return;
      }
      if (_.isBlank(ids)) {
        this.organizationsCount = 0;
        return;
      }
      return Skylark.Libs.Ajax.get(Skylark.Helpers.UrlHelper.adminUrlFor('/user_boundaries/count'), {
        data: {
          user_boundary: {
            organization_ids: ids
          }
        },
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        success: (data, xhr) => {
          return this.organizationsCount = data.organizations_count;
        }
      });
    }
  }
});
